import { CSSObject } from '@chakra-ui/react';
import {
  TButtonProp,
  TFlexPropWrapper,
  TTextProp,
} from './Propositions.styles';

export const FlexPropWrapper = ({
  propLength,
}: TFlexPropWrapper): CSSObject => ({
  ...(!!propLength && {}),
});

export const ButtonProp = ({
  propLength,
  isSelected,
}: TButtonProp): CSSObject => ({
  '&&': {
    borderRadius: 0,
    bg: 'transparent',
    boxShadow: 'none',
    border: 'none',

    '&:disabled': { bg: 'transparent' },

    ...((propLength ?? 0) === 2 && {
      p: 0,
    }),
    ...((propLength ?? 0) > 2 && {
      borderTop: '1px',
      borderTopColor: 'blackAlpha.200',
      p: '2',

      _first: { borderTop: 0 },
    }),
    ...(!!isSelected && {}),
  },
});

export const TextProp = ({ propLength, isSelected }: TTextProp): CSSObject => ({
  '&&': {
    fontSize: 'xs',

    _first: {
      color: 'white',
      fontWeight: 'bold',

      'button:hover &': { color: 'white' },

      ...((propLength ?? 0) === 2 && {
        mb: '1',
      }),
      ...((propLength ?? 0) > 2 && {
        fontSize: 'sm',
        fontWeight: 'semibold',
      }),
    },

    '&.return-amount': {
      bgGradient: isSelected
        ? 'linear(to-b, blackAlpha.500, blackAlpha.500)'
        : 'linear(to-b, alpha.100, alpha.500)',
      p: 2,
      w: 'full',
      fontSize: 'sm',
      borderRadius: 'md',
      color: isSelected ? 'alpha.400' : 'alpha.900',
      fontWeight: 'normal',
      fontFamily: 'accent',
      textShadow: isSelected
        ? '0px 0px 8px rgba(255, 159, 28, 0.5)'
        : '0px 1px 0px rgba(255, 255, 255, 0.30)',
      boxShadow: isSelected
        ? '0px 2px 4px 0px rgba(0, 0, 0, 0.3) inset, 0px 1px 0px 0px rgba(255, 255, 255, 0.15)'
        : '0px 4px 4px 0px rgba(0, 0, 0, 0.25), 0px 0px 0px 1px rgba(255, 255, 255, 0.3) inset',
      border: 'none',

      transition: 'all, .3s ease-in-out',

      _hover: {
        bgGradient: 'linear(to-b, alpha.300, alpha.300)',
        boxShadow:
          '0px 4px 4px 0px rgba(0, 0, 0, 0.25), 0px 0px 0px 1px rgba(255, 255, 255, 0.3) inset',
        color: 'alpha.900',
        textShadow: '0px 1px 1px rgba(255, 255, 255, 0.30)',
      },

      ...((propLength ?? 0) > 2 && {
        maxW: '48px',
      }),
    },

    ...(!!isSelected && {}),
  },
});
